import { toString, Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { lambda_type, unit_type, array_type, float64_type, class_type, list_type, record_type, bool_type, option_type, string_type, union_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { bind } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { DateTimeExtensions_toShortDate, strToOpt, parseInt$ } from "../../Utils.js";
import { GlobalDependencies$reflection, SaveStatus$reflection, LoadState$2$reflection } from "../../Global.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { DateTimeOffset_$007COngoing$007C_$007C, DateTimeOffset_$007CEndsInFuture$007C_$007C, DateTimeOffset_$007CEnded$007C_$007C, DateTimeOffset_$007CStartsInFuture$007C_$007C } from "../../DateUtils.js";
import { PaymentMethod$reflection } from "../../DomainTypes.js";
import { NumbersForContract$reflection, ContractTypeChange$reflection, PendingNumberForContract$reflection, SubscriptionListPhoneNumber$reflection, InvoiceeDetails$reflection, Contract$reflection } from "../Invoicee/Common.js";
import { Fee$reflection } from "../FeesTable/Model.js";
import { BillingInfo$reflection } from "../BillingInfoTable/Model.js";
import { FeeFormViewModelValues$reflection, ChartOfAccount$reflection, FeeFormTemplate$reflection } from "../FeeModal/Model.js";
import { FeeMaxDTO$reflection } from "../ContractFees/Api.js";
import { tryFind } from "../../fable_modules/fable-library.3.7.20/List.js";
import { FSharpMap__TryFind } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { FeeDTO$reflection } from "../../Redux/Reducers/InvoiceeReducer.js";
import { CreateFeeDTOV2$reflection } from "../../Api/Fee.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ContractList", "Overview", "Fees", "Attributes", "FrozenMonths", "Telecom", "History", "Traffic", "Subproduct", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.Subscriptions.Model.Page", [], Page, () => [[], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], []]);
}

export class UpdateContractDTO extends Record {
    constructor(client_cross_ref, contract_number, contract_type_code, created_by, created_time, end_user, end_user_category, end_user_organizationnr, no_next_invoice, object_number, product_number, specified_invoice, start_date, updated_time) {
        super();
        this.client_cross_ref = client_cross_ref;
        this.contract_number = contract_number;
        this.contract_type_code = contract_type_code;
        this.created_by = created_by;
        this.created_time = created_time;
        this.end_user = end_user;
        this.end_user_category = end_user_category;
        this.end_user_organizationnr = end_user_organizationnr;
        this.no_next_invoice = no_next_invoice;
        this.object_number = object_number;
        this.product_number = product_number;
        this.specified_invoice = specified_invoice;
        this.start_date = start_date;
        this.updated_time = updated_time;
    }
}

export function UpdateContractDTO$reflection() {
    return record_type("Containers.Subscriptions.Model.UpdateContractDTO", [], UpdateContractDTO, () => [["client_cross_ref", option_type(string_type)], ["contract_number", option_type(int32_type)], ["contract_type_code", string_type], ["created_by", option_type(string_type)], ["created_time", option_type(string_type)], ["end_user", option_type(string_type)], ["end_user_category", option_type(string_type)], ["end_user_organizationnr", option_type(string_type)], ["no_next_invoice", option_type(bool_type)], ["object_number", option_type(int32_type)], ["product_number", option_type(int32_type)], ["specified_invoice", option_type(bool_type)], ["start_date", option_type(string_type)], ["updated_time", option_type(string_type)]]);
}

export class ContractTerminationInfo extends Record {
    constructor(ActiveNumbers, BoundTo, FinalInvoiceAmountExclVat, FinalInvoiceAmountIncVat) {
        super();
        this.ActiveNumbers = ActiveNumbers;
        this.BoundTo = BoundTo;
        this.FinalInvoiceAmountExclVat = FinalInvoiceAmountExclVat;
        this.FinalInvoiceAmountIncVat = FinalInvoiceAmountIncVat;
    }
}

export function ContractTerminationInfo$reflection() {
    return record_type("Containers.Subscriptions.Model.ContractTerminationInfo", [], ContractTerminationInfo, () => [["ActiveNumbers", list_type(string_type)], ["BoundTo", class_type("System.DateOnly")], ["FinalInvoiceAmountExclVat", float64_type], ["FinalInvoiceAmountIncVat", float64_type]]);
}

export class PhoneNumber extends Record {
    constructor(ActiveFrom, ActiveTo, Imsi, NumberFrom, NumberTo) {
        super();
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.Imsi = Imsi;
        this.NumberFrom = NumberFrom;
        this.NumberTo = NumberTo;
    }
}

export function PhoneNumber$reflection() {
    return record_type("Containers.Subscriptions.Model.PhoneNumber", [], PhoneNumber, () => [["ActiveFrom", class_type("System.DateTime")], ["ActiveTo", option_type(class_type("System.DateTime"))], ["Imsi", option_type(class_type("System.UInt64"))], ["NumberFrom", string_type], ["NumberTo", string_type]]);
}

export class ClientObject extends Record {
    constructor(ClientObjectNr, ObjectDescription) {
        super();
        this.ClientObjectNr = (ClientObjectNr | 0);
        this.ObjectDescription = ObjectDescription;
    }
}

export function ClientObject$reflection() {
    return record_type("Containers.Subscriptions.Model.ClientObject", [], ClientObject, () => [["ClientObjectNr", int32_type], ["ObjectDescription", string_type]]);
}

export class Modal extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Nothing", "CreateSubscription", "TerminateSubscription", "TransferContractWithHistory", "UpdateContractType", "DeleteSubscription"];
    }
}

export function Modal$reflection() {
    return union_type("Containers.Subscriptions.Model.Modal", [], Modal, () => [[], [], [], [], [], []]);
}

export class TerminationOptions extends Record {
    constructor(NoFinalInvoice) {
        super();
        this.NoFinalInvoice = NoFinalInvoice;
    }
}

export function TerminationOptions$reflection() {
    return record_type("Containers.Subscriptions.Model.TerminationOptions", [], TerminationOptions, () => [["NoFinalInvoice", bool_type]]);
}

export class TerminateContractAt extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["BoundToDate", "CustomDate"];
    }
}

export function TerminateContractAt$reflection() {
    return union_type("Containers.Subscriptions.Model.TerminateContractAt", [], TerminateContractAt, () => [[], []]);
}

export function parseTerminateContractAt(_arg) {
    switch (_arg) {
        case toString(new TerminateContractAt(0)): {
            return new TerminateContractAt(0);
        }
        case toString(new TerminateContractAt(1)): {
            return new TerminateContractAt(1);
        }
        default: {
            throw (new Error(toText(printf("Cannot parse \u0027%s\u0027 into EndContractAt type."))(_arg)));
        }
    }
}

export class TerminateContractAmountRemaining extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["InvoiceAmountOnFinalInvoice", "GiveItForFree"];
    }
}

export function TerminateContractAmountRemaining$reflection() {
    return union_type("Containers.Subscriptions.Model.TerminateContractAmountRemaining", [], TerminateContractAmountRemaining, () => [[], []]);
}

export function parseTerminateContractAmountRemaining(_arg) {
    switch (_arg) {
        case toString(new TerminateContractAmountRemaining(0)): {
            return new TerminateContractAmountRemaining(0);
        }
        case toString(new TerminateContractAmountRemaining(1)): {
            return new TerminateContractAmountRemaining(1);
        }
        default: {
            throw (new Error(toText(printf("Cannot parse \u0027%s\u0027 into TerminateContractAmountRemaining type."))(_arg)));
        }
    }
}

export function formatContractTransferSearchInvoicee(name, invoiceeNr) {
    return toText(printf("%s (%i)"))(name)(invoiceeNr);
}

export class InfoTableViewModel extends Record {
    constructor(SelectStartDate, CancelledDate, EndUser, EndUserCategory, EndUserOrgNr, SelectedClientObjectCode, ClientCrossRef) {
        super();
        this.SelectStartDate = SelectStartDate;
        this.CancelledDate = CancelledDate;
        this.EndUser = EndUser;
        this.EndUserCategory = EndUserCategory;
        this.EndUserOrgNr = EndUserOrgNr;
        this.SelectedClientObjectCode = SelectedClientObjectCode;
        this.ClientCrossRef = ClientCrossRef;
    }
}

export function InfoTableViewModel$reflection() {
    return record_type("Containers.Subscriptions.Model.InfoTableViewModel", [], InfoTableViewModel, () => [["SelectStartDate", class_type("System.DateTime")], ["CancelledDate", option_type(class_type("System.DateTime"))], ["EndUser", string_type], ["EndUserCategory", string_type], ["EndUserOrgNr", string_type], ["SelectedClientObjectCode", string_type], ["ClientCrossRef", string_type]]);
}

export function getUpdateContractDTO(vm, contract, contractType) {
    return new UpdateContractDTO(vm.ClientCrossRef, contract.ContractNumber, contractType.ContractTypeCode, void 0, void 0, vm.EndUser, vm.EndUserCategory, vm.EndUserOrgNr, void 0, bind(parseInt$, strToOpt(vm.SelectedClientObjectCode)), contractType.ProductNr, void 0, DateTimeExtensions_toShortDate(vm.SelectStartDate), void 0);
}

export class TerminateContractViewModel extends Record {
    constructor(ContractTerminationInfo, SelectedTerminateContractAt, SelectedTerminateContractAmountRemaining, SelectedTerminationDate, TerminateContractStatus, ShouldDeactivateNumbers) {
        super();
        this.ContractTerminationInfo = ContractTerminationInfo;
        this.SelectedTerminateContractAt = SelectedTerminateContractAt;
        this.SelectedTerminateContractAmountRemaining = SelectedTerminateContractAmountRemaining;
        this.SelectedTerminationDate = SelectedTerminationDate;
        this.TerminateContractStatus = TerminateContractStatus;
        this.ShouldDeactivateNumbers = ShouldDeactivateNumbers;
    }
}

export function TerminateContractViewModel$reflection() {
    return record_type("Containers.Subscriptions.Model.TerminateContractViewModel", [], TerminateContractViewModel, () => [["ContractTerminationInfo", LoadState$2$reflection(ContractTerminationInfo$reflection(), string_type)], ["SelectedTerminateContractAt", TerminateContractAt$reflection()], ["SelectedTerminateContractAmountRemaining", TerminateContractAmountRemaining$reflection()], ["SelectedTerminationDate", class_type("System.DateOnly")], ["TerminateContractStatus", SaveStatus$reflection()], ["ShouldDeactivateNumbers", bool_type]]);
}

export class TerminateContractEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SaveTerminateContract", "SavedTerminateContract", "LoadTerminateContract", "LoadedTerminateContract", "SetTerminateContractAt", "SetTerminateContractAmountRemaining", "SetTerminationDate", "SetShouldDeactivateNumber"];
    }
}

export function TerminateContractEvent$reflection() {
    return union_type("Containers.Subscriptions.Model.TerminateContractEvent", [], TerminateContractEvent, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", class_type("System.DateOnly")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [ContractTerminationInfo$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", ContractTerminationInfo$reflection()]], [["ErrorValue", string_type]]])]], [["Item", string_type]], [["Item", string_type]], [["Item", class_type("System.DateOnly")]], [["Item", bool_type]]]);
}

export class Intent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ReloadInvoiceeDetails", "ReloadInvoiceeCurrentState", "ReloadContracts", "ReloadContractTypes"];
    }
}

export function Intent$reflection() {
    return union_type("Containers.Subscriptions.Model.Intent", [], Intent, () => [[], [], [], []]);
}

export class ContractCurrentState extends Record {
    constructor(CurrentState) {
        super();
        this.CurrentState = CurrentState;
    }
}

export function ContractCurrentState$reflection() {
    return record_type("Containers.Subscriptions.Model.ContractCurrentState", [], ContractCurrentState, () => [["CurrentState", option_type(string_type)]]);
}

export class NumberStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Active", "Pending", "Inactive"];
    }
}

export function NumberStatus$reflection() {
    return union_type("Containers.Subscriptions.Model.NumberStatus", [], NumberStatus, () => [[], [], []]);
}

export function NumberStatus_GetNumberStatus(activeFromOpt, activeToOpt) {
    if (activeFromOpt != null) {
        const matchValue = [activeFromOpt, activeToOpt];
        if (DateTimeOffset_$007CStartsInFuture$007C_$007C(matchValue[0], matchValue[1]) != null) {
            return new NumberStatus(1);
        }
        else if (DateTimeOffset_$007CEnded$007C_$007C(matchValue[0], matchValue[1]) != null) {
            return new NumberStatus(2);
        }
        else if (DateTimeOffset_$007CEndsInFuture$007C_$007C(matchValue[0], matchValue[1]) != null) {
            return new NumberStatus(0);
        }
        else if (DateTimeOffset_$007COngoing$007C_$007C(matchValue[0], matchValue[1]) != null) {
            return new NumberStatus(0);
        }
        else {
            return new NumberStatus(2);
        }
    }
    else {
        return new NumberStatus(2);
    }
}

export class NumberInfoViewModel extends Record {
    constructor(NumberFrom, NumberTo, NumberStatus) {
        super();
        this.NumberFrom = NumberFrom;
        this.NumberTo = NumberTo;
        this.NumberStatus = NumberStatus;
    }
}

export function NumberInfoViewModel$reflection() {
    return record_type("Containers.Subscriptions.Model.NumberInfoViewModel", [], NumberInfoViewModel, () => [["NumberFrom", string_type], ["NumberTo", string_type], ["NumberStatus", NumberStatus$reflection()]]);
}

export function NumberInfoViewModel_OfSubscriptionListPhoneNumber_922BB38(n) {
    return new NumberInfoViewModel(n.NumberFrom, n.NumberTo, NumberStatus_GetNumberStatus(n.ActiveFrom, n.ActiveTo));
}

export function NumberInfoViewModel_OfPendingNumberForContract_Z215FFA2D(n) {
    return new NumberInfoViewModel(n.Number, n.Number, new NumberStatus(1));
}

export class Model extends Record {
    constructor(GlobalDependencies, PaymentMethod, CurrentSubscriptionPage, Contracts, ContractPhoneNumbers, CurrentSubscriptionContractNr, ErrorMessage, Fees, OpenModal, InvoiceeDetails, TerminateContractViewModel, IsEditingInfoTable, FrozenMonthConfigured, SubscriptionListPhoneNumbers, PendingPhoneNumbers, ShowCancelledSubscriptions, NumberInfoBox, ClientObjectCodes, ComingContractTypeChange, DeleteContractStatus, BillingInfo, FeeTemplates, ChartOfAccounts, MaxFee) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.PaymentMethod = PaymentMethod;
        this.CurrentSubscriptionPage = CurrentSubscriptionPage;
        this.Contracts = Contracts;
        this.ContractPhoneNumbers = ContractPhoneNumbers;
        this.CurrentSubscriptionContractNr = CurrentSubscriptionContractNr;
        this.ErrorMessage = ErrorMessage;
        this.Fees = Fees;
        this.OpenModal = OpenModal;
        this.InvoiceeDetails = InvoiceeDetails;
        this.TerminateContractViewModel = TerminateContractViewModel;
        this.IsEditingInfoTable = IsEditingInfoTable;
        this.FrozenMonthConfigured = FrozenMonthConfigured;
        this.SubscriptionListPhoneNumbers = SubscriptionListPhoneNumbers;
        this.PendingPhoneNumbers = PendingPhoneNumbers;
        this.ShowCancelledSubscriptions = ShowCancelledSubscriptions;
        this.NumberInfoBox = NumberInfoBox;
        this.ClientObjectCodes = ClientObjectCodes;
        this.ComingContractTypeChange = ComingContractTypeChange;
        this.DeleteContractStatus = DeleteContractStatus;
        this.BillingInfo = BillingInfo;
        this.FeeTemplates = FeeTemplates;
        this.ChartOfAccounts = ChartOfAccounts;
        this.MaxFee = MaxFee;
    }
}

export function Model$reflection() {
    return record_type("Containers.Subscriptions.Model.Model", [], Model, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["PaymentMethod", PaymentMethod$reflection()], ["CurrentSubscriptionPage", Page$reflection()], ["Contracts", LoadState$2$reflection(list_type(Contract$reflection()), string_type)], ["ContractPhoneNumbers", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, LoadState$2$reflection(list_type(PhoneNumber$reflection()), string_type)])], ["CurrentSubscriptionContractNr", option_type(int32_type)], ["ErrorMessage", option_type(string_type)], ["Fees", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, LoadState$2$reflection(list_type(Fee$reflection()), string_type)])], ["OpenModal", Modal$reflection()], ["InvoiceeDetails", InvoiceeDetails$reflection()], ["TerminateContractViewModel", TerminateContractViewModel$reflection()], ["IsEditingInfoTable", bool_type], ["FrozenMonthConfigured", bool_type], ["SubscriptionListPhoneNumbers", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, list_type(SubscriptionListPhoneNumber$reflection())]), string_type)], ["PendingPhoneNumbers", LoadState$2$reflection(list_type(PendingNumberForContract$reflection()), string_type)], ["ShowCancelledSubscriptions", bool_type], ["NumberInfoBox", list_type(NumberInfoViewModel$reflection())], ["ClientObjectCodes", LoadState$2$reflection(list_type(ClientObject$reflection()), string_type)], ["ComingContractTypeChange", LoadState$2$reflection(option_type(ContractTypeChange$reflection()), string_type)], ["DeleteContractStatus", SaveStatus$reflection()], ["BillingInfo", LoadState$2$reflection(option_type(BillingInfo$reflection()), string_type)], ["FeeTemplates", LoadState$2$reflection(list_type(FeeFormTemplate$reflection()), string_type)], ["ChartOfAccounts", LoadState$2$reflection(list_type(ChartOfAccount$reflection()), string_type)], ["MaxFee", LoadState$2$reflection(FeeMaxDTO$reflection(), string_type)]]);
}

export function Model__GetCurrentContract(x) {
    const matchValue = [x.Contracts, x.CurrentSubscriptionContractNr];
    let pattern_matching_result, contractNr, contracts;
    if (matchValue[0].tag === 2) {
        if (matchValue[1] != null) {
            pattern_matching_result = 0;
            contractNr = matchValue[1];
            contracts = matchValue[0].fields[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return tryFind((c) => (c.ContractNumber === contractNr), contracts);
        }
        case 1: {
            return void 0;
        }
    }
}

export function Model__GetCurrentFees(x) {
    return bind((c) => {
        const matchValue = FSharpMap__TryFind(x.Fees, c.ContractNumber);
        let pattern_matching_result, fees;
        if (matchValue != null) {
            if (matchValue.tag === 2) {
                pattern_matching_result = 0;
                fees = matchValue.fields[0];
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                return fees;
            }
            case 1: {
                return void 0;
            }
        }
    }, Model__GetCurrentContract(x));
}

export function Model__GetCurrentContractType_789D039B(x, contractTypes) {
    return bind((c) => {
        if (contractTypes.tag === 2) {
            return FSharpMap__TryFind(contractTypes.fields[0], c.ContractTypeCode);
        }
        else {
            return void 0;
        }
    }, Model__GetCurrentContract(x));
}

export function Model_GetCurrentNetworkContractNr(model, contractTypes) {
    return bind((contractType) => contractType.NetworkContractNr, Model__GetCurrentContractType_789D039B(model, contractTypes));
}

export class SubscriptionsMsg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LoadedGlobalDependencies", "LoadedInvoiceeDetails", "LoadContracts", "LoadedContracts", "PageChanged", "RouterNavigate", "LoadFees", "LoadedFees", "LoadPhoneNumber", "LoadedPhoneNumber", "OpenModal", "TerminateContractEvent", "SavedChangeContractType", "LoadContractPhoneNumbers", "LoadedContractPhoneNumbers", "ToggleShowAllSubscriptions", "ShowNumberInfo", "HideNumberInfo", "SaveContract", "SavedContract", "LoadClientObjects", "LoadedClientObjects", "LoadComingContractTypeChange", "LoadedComingContractTypeChange", "TriggerContractState", "TriggeredContractState", "DeleteContract", "DeletedContract", "ResetDeleteContractStatus", "LoadBillingInfo", "LoadedBillingInfo", "LoadFeeTemplates", "LoadedFeeTemplates", "LoadChartOfAccounts", "LoadedChartOfAccounts", "LoadMaxFee", "LoadedMaxFee", "CreateFee", "CreatedFee", "Intent"];
    }
}

export function SubscriptionsMsg$reflection() {
    return union_type("Containers.Subscriptions.Model.SubscriptionsMsg", [], SubscriptionsMsg, () => [[["Item", GlobalDependencies$reflection()]], [["Item", InvoiceeDetails$reflection()]], [], [["Item", LoadState$2$reflection(list_type(Contract$reflection()), string_type)]], [["Item", Page$reflection()]], [["Item", array_type(string_type)]], [["Item", int32_type]], [["Item1", int32_type], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(FeeDTO$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(FeeDTO$reflection())]], [["ErrorValue", string_type]]])]], [["Item", int32_type]], [["Item1", int32_type], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(PhoneNumber$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(PhoneNumber$reflection())]], [["ErrorValue", string_type]]])]], [["Item", Modal$reflection()]], [["Item", TerminateContractEvent$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", list_type(Contract$reflection())]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [NumbersForContract$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", NumbersForContract$reflection()]], [["ErrorValue", string_type]]])]], [], [["Item", int32_type]], [], [["Item1", InfoTableViewModel$reflection()], ["Item2", Contract$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ClientObject$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ClientObject$reflection())]], [["ErrorValue", string_type]]])]], [["Item", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ContractTypeChange$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ContractTypeChange$reflection())]], [["ErrorValue", string_type]]])]], [["Item1", int32_type], ["Item2", list_type(lambda_type(lambda_type(SubscriptionsMsg$reflection(), unit_type), unit_type))]], [["Item1", union_type("Microsoft.FSharp.Core.FSharpResult`2", [ContractCurrentState$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", ContractCurrentState$reflection()]], [["ErrorValue", string_type]]])], ["Item2", int32_type], ["Item3", list_type(lambda_type(lambda_type(SubscriptionsMsg$reflection(), unit_type), unit_type))]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])]], [], [["Item", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(BillingInfo$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", option_type(BillingInfo$reflection())]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(FeeFormTemplate$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(FeeFormTemplate$reflection())]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ChartOfAccount$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ChartOfAccount$reflection())]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [FeeMaxDTO$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", FeeMaxDTO$reflection()]], [["ErrorValue", string_type]]])]], [["Item", FeeFormViewModelValues$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [CreateFeeDTOV2$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", CreateFeeDTOV2$reflection()]], [["ErrorValue", string_type]]])]], [["Item", Intent$reflection()]]]);
}

